module.exports = __webpack_public_path__ + "images/emoji/arrow_heading_up.2d5f39371a717ae41cd9.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/arrow_heading_up.png
// module id = jgsa
// module chunks = 14